export default __webpack_public_path__ + "static/IN-8015_8mm_lense_day-6c478cda19a4d1309e0de4b4172ea17c.webp";